import { app } from '../../../../app';
import { Controller } from './application-configuration-form.controller';

app.component('applicationConfigurationForm', {
    bindings: {
        applicationConfiguration: '<',
        companyDomains: '<',
        onChange: '&',
        onEnter: '&',
        onSaveName: '&',
    },
    controller: Controller,
    templateUrl: require('./application-configuration-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration-form.component.js